import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/UI/Table/Table';
import * as actions from '../../store/actions/index';
import Spinner from '../../components/UI/Spinner/Spinner';

class Documents extends Component {
    componentDidMount () {
        this.props.onFetchDocuments();
    }

    render () {
        let documents = <Spinner />;
        if ( !this.props.loading ) {
            var data = [];
            documents = this.props.documents.map( document => (
                data.push({
                    oid: document.id, data: [{
                        value: 'Title: ' + document.Title,
                        target : '_blank',
                        link : 'https://mulchdocs.mescout.org/' + document.DocumentName,
                        style: { paddingLeft: "40px", width: "400px" }
                    }
                ]
            }
            )));

            var header = [{
                name: "Documents",
                style: { paddingLeft: "40px", width: "400px" }
            }];

            return (
                <div>
                    <Table header={header} data={data}></Table>
                </div>       
                 );
        }
        else
        {
            return (
                <div>
                {documents}
                </div>
            )
        }
        
        
        
    }
};

const mapStateToProps = state => {
    return {
        documents: state.documents.documents,
        loading: state.documents.loading,
        isAuthenticated: state.orders.token !== null
    };
}
const mapDispatchToProps = dispatch => {
    return {
        onFetchDocuments: () => dispatch( actions.fetchDocuments() )
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(Documents);


// WEBPACK FOOTER //
// ./src/components/Documents/Documents.js